import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getSolicitacoesProcedimento(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("solicitacaoExames/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    obterSolicitacaoPorAtendimentoProduto(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("solicitacaoExames/access/obterPorAtendimentoProduto", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async getSolicitacoesPorAtendimento(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para consultar os dados do atendimento."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("solicitacaoExames/access/listaPorAtendimento", dados, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Resposta inválida ao consultar os dados do atendimento."); }
        return data;
    },
    getSolicitacoesNaoRealizadas(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("solicitacaoExames/access/listaNaoRealizados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvarSimplesSolicitacao(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("solicitacaoExames/access/salvarSimples", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }  
};

export default {
  state,
  actions,
  mutations,
  getters
};